module.exports = __webpack_public_path__ + "static/media/shivam.23758dfd.jpg";